import React from "react";

import styles from "./About.module.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

const Page = () => (
  <main className={styles.container}>
    <Header />
    <div className={styles.wrapper}>
      <a href="/" className={styles.backTop}>
        <img src="/images/backButton.svg" alt="Voltar" />
      </a>
      <a href="/" className={styles.logo}>
        <img src="/images/logo white.svg" alt="Iconic Minds" />
      </a>
      <div className={styles.content}>
        <p>
          <strong>A Iconic Minds</strong> nasceu quase por acaso, quando dois
          amigos e sócios, David e Alberto , arrastaram (sim, arrastaram mesmo!)
          as suas mulheres, para um espetáculo de Victor Küppers em Barcelona.
        </p>
        <p>
          No início, elas estavam um pouco reticentes, a pensar "lá vem mais uma
          palestra motivacional...", mas no final, as duas deixaram-se levar e o
          entusiasmo tomou conta dos quatro! A mensagem era simples, mas
          profundamente transformadora – e impactou-os tanto que, desde então,
          não só começaram a ver a vida de uma forma diferente, como decidiram
          querer inspirar todos à sua volta a fazer o mesmo.
        </p>
        <p>
          E assim surgiu a Iconic Minds: uma comunidade que, com base na
          psicologia positiva, ajuda as pessoas a viver com mais alegria,
          entusiasmo e boa energia.
        </p>
        <p>
          <strong>
            Porque, no fundo, (quase) tudo se resume a uma questão de
            perpectiva!
          </strong>
        </p>
      </div>
      <a href="/" className={styles.backBottom}>
        <img src="/images/backButton.svg" alt="Voltar" />
      </a>
    </div>
    <Footer />
  </main>
);

export default Page;
